export default __webpack_public_path__ + "static/media/cuprovyg.18130c93.png";